import { render, staticRenderFns } from "./OneOnOneUser.vue?vue&type=template&id=5907acf7&scoped=true"
import script from "./OneOnOneUser.vue?vue&type=script&lang=js"
export * from "./OneOnOneUser.vue?vue&type=script&lang=js"
import style0 from "./OneOnOneUser.vue?vue&type=style&index=0&id=5907acf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5907acf7",
  null
  
)

export default component.exports